<template>
  <div>
    <div
      @click="open"
      :class="{ calendar_checked: checked }"
      class="icon_calendar"
    >
      <font-awesome-icon
        :icon="['far', 'calendar-check']"
        class="color-primary"
      ></font-awesome-icon>
    </div>
    <transition name="slide">
      <div
        v-show="checked"
        class="container_calendar p-0"
        style="overflow-y: auto; overflow-x: hidden"
      >
        <div class="row" v-show="list_show">
          <div class="col-lg-12 p-0 col-xs-12">
            <div class="pl-4 pr-4">
              <p class="f20 mt-2 color-grey-primary">
                Agenda
                <inertia-link href="/recruiters/calendars/list">
                  <font-awesome-icon
                    class="pointer right"
                    :icon="['fas', 'external-link-alt']"
                  />
                </inertia-link>
              </p>
            </div>
          </div>
          <div class="col-lg-12 p-0 col-xs-12">
            <div class="scroll_calendar">
              <div v-show="calendars.length > 0" class="pl-3 pr-3">
                <div class v-for="(event, index) in calendars" :key="index">
                  <div
                    class="header_day"
                    :class="{ hide: event.total_day == 0 }"
                  >
                    {{ event.day | moment("ll") }}
                    <span class="f12 right mr-2">
                      total:
                      <b>{{ event.total_day }}</b>
                    </span>
                  </div>
                  <div v-for="(day, key) in event.events" :key="key" class>
                    <div
                      :class="{ opacity_4: day.status == 0 }"
                      class="pl-4 pr-4 calendar_unique"
                    >
                      <div class="row">
                        <div
                          :class="{
                            hours_true: day.status == 1,
                            hours_false: day.status == 0,
                          }"
                          class="pl-0 pr-0 col-xs-2 col-lg-2"
                        >
                          <div>
                            <span>{{ day.start_date | moment("LT") }}</span>
                          </div>
                          <div>
                            <span>{{ day.end_date | moment("LT") }}</span>
                          </div>
                        </div>
                        <div class="col-xs-10 col-lg-10">
                          <p
                            @click="setEventCalendar(day)"
                            class="pointer text-truncate mb-0"
                            style="max-width: 220px"
                          >
                            {{ day.title }}
                          </p>

                          <a
                            v-if="
                              $moment(day.start_date).subtract(1, 'hours') <=
                                $moment() &&
                              $moment(day.end_date).add(1, 'hours') >= $moment()
                            "
                            :href="day.room_link"
                            target="_blank"
                          >
                            <font-awesome-icon
                              style="margin-top: -10px"
                              icon="video"
                              class="pointer right f15 color-primary"
                            ></font-awesome-icon>
                          </a>
                          <p
                            class="text-truncate dark_grey mb-0"
                            style="max-width: 250px"
                          >
                            {{ day.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="(calendars.length = 0)" class="pl-4 center pr-4">
                <sweetalert-icon icon="loading" />
              </div>
              <div v-show="no_calendar">
                <div class="pl-4 pr-4">
                  <p>NÃO HÁ AGENDAMENTOS FUTUROS</p>
                </div>
              </div>
            </div>

            <div class="pl-4 pr-4">
              <button
                type="button"
                class="btn full mb-2 btn-degrade normal-degrade"
                @click="newCalendar"
              >
                NOVO AGENDAMENTO
              </button>
            </div>
          </div>
        </div>
        <div v-show="!list_show" class="row p-0 m-0">
          <div class="col-lg-12 p-0 col-xs-12">
            <div class="pl-4 pr-4">
              <p class="mt-3 mb-0 pointer" @click="back">
                <font-awesome-icon
                  icon="chevron-left"
                  class="mr-2"
                ></font-awesome-icon>
                <span>VOLTAR</span>
              </p>
            </div>
          </div>
          <div class="scroll_calendar_full row">
            <div class="col-lg-12 p-0 col-xs-12">
              <div class="pl-4 pr-4">
                <inputform
                  v-model="calendar.title"
                  type="text"
                  label
                  placeholder="Título da agenda"
                  :field="$v.calendar.title"
                  class="label-bold"
                />
              </div>
            </div>
            <div class="col-lg-12 p-0 col-xs-12">
              <div
                class="pl-4 pr-4 mb-2"
                v-for="(item, index) in emails"
                :key="index"
              >
                <span class="email_select_calendar f12">
                  {{ item }}
                  <font-awesome-icon
                    @click="removeEmail(index)"
                    icon="times"
                    class="ml-2 mr-1 pointer"
                  ></font-awesome-icon>
                </span>
              </div>
            </div>
            <div class="col-lg-12 p-0 col-xs-12">
              <div class="pl-4 pr-4">
                <vue-suggestion
                  class
                  :items="[]"
                  v-model="person_select"
                  :setLabel="setLabel"
                  :itemTemplate="itemTemplate"
                  @changed="inputChange"
                  @selected="itemSelected"
                  @enter="addEmail($event)"
                  placeholder="Emails participantes"
                ></vue-suggestion>
                <span class="f12 ml-3">PRESSIONE ENTER PARA ADICIONAR</span>
              </div>
            </div>
            <div class="col-lg-12 p-0 col-xs-12">
              <div class="pl-4 pr-4">
                <Datepicker
                  input-class="form-control"
                  class="mt-3 p-0"
                  :format="customFormatter"
                  placeholder="Data do evento"
                  v-model="date_current"
                  :language="ptBR"
                ></Datepicker>
              </div>
            </div>
            <div class="col-lg-5 p-0 col-xs-12 pl-0 ml-0">
              <div class="pl-4 mt-3 pr-0">
                <input
                  class="form-control"
                  v-model="start_hour"
                  v-on:keydown.tab="autoCompleteStartHour()"
                  v-mask="['##:##']"
                />
              </div>
            </div>
            <div class="col-lg-2 pt-4" style="width: 30px">
              <span class>ATÉ</span>
            </div>
            <div class="col-lg-5 p-0 col-xs-12 pr-0 mr-0">
              <div class="pl-0 mt-3 pr-4">
                <input
                  class="form-control"
                  v-model="end_hour"
                  v-on:keydown.tab="autoCompleteEndHour()"
                  v-mask="['##:##']"
                />
              </div>
            </div>
            <div class="col-lg-12 pl-4 pr-4 col-xs-12">
              <CheckBox
                class="mt-3"
                id="1"
                :checked="use_room"
                label="CRIAR SALA DE REUNIÃO NA JOVOOL"
                index="0"
              />
            </div>
            <div class="col-lg-12 col-xs-12 p-0">
              <div class="pl-4 pr-4">
                <textareaform
                  label="DESCRIÇÃO"
                  class="mt-3"
                  rows="4"
                  :field="$v.calendar.description"
                  v-model="calendar.description"
                ></textareaform>
              </div>
            </div>
            <div v-if="calendar.id != 0" class="col-lg-12 col-xs-12 p-0">
              <div class="pl-4 pr-4">
                <label>Status do evento</label>
                <select v-model="calendar.status" class="form-control">
                  <option :value="1" selected>Ativo</option>
                  <option :value="0">Cancelado</option>
                </select>
              </div>
            </div>
            <div class="col-lg-12 p-0">
              <div class="pl-4 mt-3 mb-2 pr-4">
                <a class="mt-2 mb-3" :href="link">{{ link }}</a>
                <button
                  @click="save"
                  type="button"
                  class="btn full mt-2 mb-2 normal-degrade btn-degrade"
                >
                  <div v-show="!load">
                    <font-awesome-icon
                      icon="plus"
                      class="mr-2"
                    ></font-awesome-icon
                    >SALVAR EVENTO
                  </div>
                  <div v-show="load">
                    <div class="spinner-border text-light" role="status">
                      <span class="sr-only"></span>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import moment from "moment";
import { required, minLength, email } from "vuelidate/lib/validators";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import itemTemplate from "components/ItemTemplate.vue";
import CheckBox from "components/CheckBox.vue";
export default {
  components: { Datepicker, CheckBox },
  data: () => ({
    load: false,
    ptBR: ptBR,
    checked: false,
    moment_method: () => {
      return moment;
    },
    person_select: { title: "" },
    date_current: moment().format(),
    list_show: true,
    selected: "A",
    calendar: {
      id: 0,
      title: "",
      description: "",
      start_date: moment().format(),
      end_date: moment().format(),
      status: "1",
    },
    calendars: [],
    start_hour: moment().format("HH:mm"),
    end_hour: moment().add(30, "minutes").format("HH:mm"),
    use_room: true,
    emails_current: "",
    emails: [],
    itemTemplate,
    link: "",
    no_calendar: false,
  }),
  mounted() {
    eventBus.$on("checkbox", (field) => {
      this.use_room = field.operator;
    });
  },
  methods: {
    autoCompleteStartHour() {
      if (this.start_hour.length <= 4) {
        for (let sizeHour = this.start_hour.length; sizeHour <= 4; sizeHour++) {
          this.start_hour = this.start_hour + "0";
        }
      }
    },
    autoCompleteEndHour() {
      if (this.end_hour.length <= 4) {
        for (let sizeHour = this.end_hour.length; sizeHour <= 4; sizeHour++) {
          this.end_hour = this.end_hour + "0";
        }
      }
    },
    setEventCalendar(event) {
      axios
        .get(`/recruiters/calendars/${event.id}`)
        .then((response) => {
          this.calendar = {
            id: response.data.calendar.id,
            title: response.data.calendar.title,
            description: response.data.calendar.description,
            start_date: moment(response.data.calendar.start_date),
            end_date: moment(response.data.calendar.end_date),
            status: response.data.calendar.status,
          };

          this.link = response.data.room_link;

          this.date_current = moment(
            response.data.calendar.start_date
          ).format();
          this.start_hour = moment(response.data.calendar.start_date).format(
            "HH:mm"
          );
          this.end_hour = moment(response.data.calendar.end_date).format(
            "HH:mm"
          );
          this.emails = response.data.invited_calendars.map((invited) => {
            return invited.email;
          });
          this.list_show = false;
        })
        .catch((err) => {
          this.$toast.error("Erro ao tentar editar um agendamento.");
        });
    },
    newCalendar() {
      this.calendar = {
        id: 0,
        title: "",
        description: "",
        start_date: this.$moment().format(),
        end_date: this.$moment().format(),
        status: 1,
      };
      this.emails = [];
      document.querySelector(".vs__input-group input").value = "";
      this.date_current = moment().format();
      this.link = "";
      this.list_show = false;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    removeEmail(index) {
      if (this.calendar.id != 0) {
        let conf = confirm(
          "Tem certeza que deseja excluir esse contato do evento?"
        );
        if (!conf) return;
        axios
          .delete(
            `/recruiters/calendars/${this.calendar.id}/emails?email=${this.emails[index]}`
          )
          .then((reponse) => {
            this.emails.splice(index, 1);
            return;
          });
      } else {
        this.emails.splice(index, 1);
      }
    },
    open() {
      this.checked = !this.checked;

      if (this.checked == true) {
        this.loadCalendar();
      }
    },
    loadCalendar() {
      this.calendars = [];
      axios.get("/recruiters/calendars").then((response) => {
        this.calendars = response.data.calendars;
        this.no_calendar = false;
        if (this.calendars.length == 0) {
          this.no_calendar = true;
        }
      });
    },
    setLabel(item) {
      return item.title;
    },
    itemSelected(item) {
      this.person_select.title = "a";
    },
    back() {
      this.list_show = true;
      this.loadCalendar();
    },
    addEmail(event) {
      this.$v.emails_current.$touch();
      if (this.$v.emails_current.$invalid) {
        this.$toast.error("Tem que ser um email válido");
        return;
      }

      if (this.emails.includes(this.emails_current)) {
        this.$toast.error("Email repitido");
        return;
      }
      if (this.calendar.id != 0) {
        axios
          .post(`/recruiters/calendars/${this.calendar.id}/emails`, {
            emails: { contacts: [this.emails_current] },
          })
          .then((reponse) => {
            return;
          });
      }
      this.emails.push(this.emails_current);
      this.emails_current = "";
      this.person_select.title = "";
      document.querySelector(".vs__input-group input").value = "";
    },
    inputChange(text) {
      this.emails_current = text;
      // axios
      //   .get(`/recruiters/jobs_search?term=${text}`)
      //   .then((response) => {
      //     this.jobs = response.data.jobs;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    save() {
      if (this.load) return;
      this.load = true;
      this.$v.calendar.$touch();
      if (this.$v.calendar.$invalid) {
        this.$toast.error("Preencha corretamente os dados para continuar");
        this.load = false;
        return;
      }

      let email_lot =
        this.emails.length == 0 ? [this.emails_current] : this.emails;
      if (email_lot[0] == "") {
        this.$toast.error("Não há convidados para essa agenda.");
        this.load = false;
        return;
      }

      let calendar_current = {
        title: this.calendar.title,
        description: this.calendar.description,
        status: this.calendar.status,
        start_date: `${moment(this.date_current).format("YYYY-MM-DD")} ${
          this.start_hour
        }`,
        end_date: `${moment(this.date_current).format("YYYY-MM-DD")} ${
          this.end_hour
        }`,
      };

      if (this.calendar.id == 0) {
        axios
          .post("/recruiters/calendars", {
            calendars: calendar_current,
            rooms: { use_room: this.use_room },
            emails: {
              contacts:
                this.emails.length == 0 ? [this.emails_current] : this.emails,
            },
          })
          .then((response) => {
            this.load = false;
            this.$toast.success("Evento cadastrado com sucesso");
            this.calendar.id = response.data.calendar.id;
            this.link = response.data.room_link;
          })
          .catch((err) => {
            this.load = false;
          });
        return;
      }
      axios
        .put(`/recruiters/calendars/${this.calendar.id}`, {
          calendars: calendar_current,
        })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success("Evento cadastrado com sucesso");
          } else {
            this.$toast.error("Erro ao cadastrar evento");
          }
          this.load = false;
        })
        .catch((err) => {
          this.load = false;
        });
    },
  },
  validations: {
    calendar: {
      title: { required, minLength: minLength(4) },
      description: { minLength: minLength(5) },
    },
    emails_current: { email },
  },
};
</script>
